import { render, staticRenderFns } from "./DashboardMessages.vue?vue&type=template&id=13df0df3&"
import script from "./DashboardMessages.vue?vue&type=script&lang=js&"
export * from "./DashboardMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports